import React from 'react'
import { Provider } from 'react-redux'
import { compose } from 'redux'
import { hot } from 'react-hot-loader/root'
import useStore from 'store'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Routes from 'routes/public'
import isDevelop from 'utils/isDevelop'
import chromeExtComposer from 'utils/chromeExtComposer'
import Navbar from 'components/shared/navbar'
import Footer from 'components/shared/footer'
import loadable from '@loadable/component'

const PPCSGLandingPage = loadable(() => import('components/public/ppc-sg'))
const PPCPHLandingPage = loadable(() => import('components/public/ppc-ph'))

const composer = isDevelop ? chromeExtComposer : compose

const { preloadedState } = window

const store = useStore(composer, preloadedState)

const Client = () => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path="/ppc-sg" component={PPCSGLandingPage} />
        <Route exact path="/ppc-ph" component={PPCPHLandingPage} />
        <Route>
          <>
            <Navbar />
            <Routes />
            <Footer />
          </>
        </Route>
      </Switch>
    </Router>
  </Provider>
)

export default hot(Client)
